import { cva, type VariantProps } from 'class-variance-authority';

export const sponsoredCardVariants = cva(
  'bg-neutral-50 rounded-lg border border-secondary-700 overflow-hidden flex flex-col gap-lg px-info-card-med-sides py-info-card-med-top-bottom',
);

export type SponsoredCardVariantProps = VariantProps<
  typeof sponsoredCardVariants
>;

// Arbitrary logo dimensions match Figma spec: 90x51 (mobile) / 108x62 (desktop) — no token equivalent
export const sponsoredCardLogoBoxVariants = cva(
  'flex shrink-0 items-center justify-center rounded bg-white shadow-xl overflow-hidden w-[90px] h-[51px] md:w-[108px] md:h-[62px] p-xxs',
);
